import { useState, useEffect, useRef } from 'react';
import firebaseService from '../services/firebaseService';

// Hent delings-ID fra URL-en. Ny lenkeform er "/dele/<id>" (path), som gjør at
// Firebase Hosting kan rute forespørselen til sharePreview-funksjonen for
// server-side Open Graph-metadata (crawlere kjører ikke JS, se functions/index.js).
// Gamle lenker med "?share=<id>" (query) fungerer fortsatt for bakoverkompatibilitet.
function getShareIdFromUrl() {
  const pathMatch = window.location.pathname.match(/^\/dele\/([^/]+)/);
  if (pathMatch) return pathMatch[1];
  return new URLSearchParams(window.location.search).get('share');
}

export function useSharedCatch() {
  // Initialiser loading=true SYNKRONT hvis URL-en peker på en delt fangst.
  // Uten dette er loading=false ved første render, mens auth allerede er ferdig.
  // Da faller App gjennom til forsiden i det korte vinduet før effekten under
  // rekker å sette loading=true — som er grunnen til at en delt lenke viste
  // forsiden første gang, men fungerte ved neste åpning.
  const hasShareParam = Boolean(getShareIdFromUrl());
  // Stabil markør for at denne økten startet fra en delt lenke. Beholdes selv
  // etter at URL-en er ryddet opp, slik at App fortsatt vet at den skal vise
  // delt-visning (eller en feilmelding) og ikke forsiden.
  const isShareRef = useRef(hasShareParam);
  const [sharedCatch, setSharedCatch] = useState(null);
  const [loading, setLoading] = useState(hasShareParam);
  const [error, setError] = useState(null);

  useEffect(() => {
    const shareId = getShareIdFromUrl();

    if (!shareId) {
      return;
    }

    const fetchShared = async () => {
      setLoading(true);
      setError(null);

      try {
        const data = await firebaseService.getSharedCatch(shareId);
        setSharedCatch(data);
      } catch (error) {
        console.error('Failed to fetch shared catch:', error);
        setError(error.message);
      } finally {
        setLoading(false);
        // Rydd /dele/<id> (eller gammel ?share=) fra adresselinjen etter at
        // delingen er hentet. Visningen ligger allerede i state, så den blir
        // stående. Dette hindrer at en reload eller tilbake-navigasjon låser
        // brukeren i delt-visning, og at lenken videredeles ved et uhell.
        window.history.replaceState({ view: 'shared-view' }, '', window.location.origin + '/');
      }
    };

    fetchShared();
  }, []);

  return {
    sharedCatch,
    loading,
    error,
    isShare: isShareRef.current
  };
}